import { useState } from 'react';

const EMAIL = 'info@daverosetholley.com';

const CopyEmail = () => {
    const [copied, setCopied] = useState(false);
    const copy = async () => {
        try {
            await navigator.clipboard.writeText(EMAIL);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch {
            window.location.href = `mailto:${EMAIL}`;
        }
    };
    return (
        <button
            type="button"
            onClick={copy}
            aria-live="polite"
            className={`shrink-0 rounded-full border px-4 py-1.5 text-[11px] uppercase tracking-[0.2em] font-semibold transition-all duration-300 ${copied ? 'border-[#c93a22] bg-[#c93a22] text-white' : 'border-charcoal/20 text-charcoal/70 hover:border-charcoal hover:text-charcoal'}`}
        >
            {copied ? 'Copied ✓' : 'Copy'}
        </button>
    );
};

export const Contact = () => {
    return <section id="contact" className="relative flex items-center justify-center py-24 md:py-40 px-5 sm:px-10 lg:px-20">
        <div className='fade-in text-charcoal max-w-7xl mx-auto w-full animate-fade-in-up'>
            <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center stagger-children [&>*]:min-w-0">
                {/* Left side - Big statement */}
                <div>
                    <p className='eyebrow mb-6'>Let's Connect</p>
                    <h2 className='text-5xl md:text-7xl lg:text-8xl font-grandslang w-4/5 mb-8'> Have a project in mind? </h2>
                    <div className='w-20 h-[2px] bg-[#ff6347]'></div>
                </div>
                {/* Right side - Contact info and CTAs */}
                <div className='space-y-8'>
                    <p className='text-xl md:text-2xl text-charcoal/70 leading-relaxed'> I'm always open to new opportunities, collaborations, and meaningful conversations. </p>
                    {/* Contact methods */}
                    <div className='space-y-4'>
                        <div className='group'>
                            <p className='eyebrow mb-2'>Email</p>
                            <div className='flex flex-wrap items-center gap-x-5 gap-y-3'>
                                <a href={`mailto:${EMAIL}`} className='text-xl sm:text-2xl md:text-3xl font-medium text-charcoal hover:text-[#c93a22] transition-colors duration-300 break-all'>{EMAIL}</a>
                                <CopyEmail />
                            </div>
                        </div>
                        <div className='group'>
                            <p className='eyebrow mb-2'>Social</p>
                            <a target="_blank" rel="noopener noreferrer" href='https://www.linkedin.com/in/daverose-tholley-915a7b151/' className='text-2xl md:text-3xl font-medium text-charcoal hover:text-[#ff6347] transition-colors duration-300'> LinkedIn → </a>
                        </div>
                    </div>
                    {/* Availability badge */}
                    <div className='flex items-center gap-3 pt-6 border-t border-charcoal/10'>
                        <div className='w-3 h-3 rounded-full bg-[#ff6347] animate-pulse'></div>
                        <p className='text-sm text-charcoal/70'>Available for freelance work</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
}